import React from 'react';
import { mediaUrl } from '../utils/media';
import { DONATE_URL } from '../utils/donate';

interface Cause {
  category: string;
  title: string;
  description: string;
  goal: string;
  raised: string;
  percentage: number;
  image: string;
}

const CausesSection: React.FC = () => {
  const causes: Cause[] = [
    {
      category: 'Education',
      title: 'Education For Indian Children',
      description: 'Providing quality education and learning resources to children in need across India.',
      goal: '₹10,00,000',
      raised: '₹9,54,200',
      percentage: 90,
      image: mediaUrl('Photo from Anand Mashatte(23).jpg'),
    },
    {
      category: 'Tree Plantation',
      title: 'Plant Trees, Save Lives',
      description: 'Planting trees to combat climate change, restore ecosystems, and create greener communities for future generations.',
      goal: '₹10,00,000',
      raised: '₹7,25,000',
      percentage: 72,
      image: mediaUrl('Photo from Anand Mashatte(39).jpg'),
    },
  ];

  return (
    <div className="container-xxl bg-light my-5 py-5">
      <div className="container py-5">
        <div className="text-center mx-auto mb-5" data-aos="fade-up" data-aos-delay="100" style={{ maxWidth: '500px' }}>
          <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
            Feature Causes
          </div>
          <h1 className="display-6 mb-5">Every Child Deserves The Opportunity To Learn</h1>
        </div>
        <div className="causes-grid">
          {causes.map((cause, index) => (
            <div key={index} data-aos="fade-up" data-aos-delay={`${100 + index * 200}`}>
              <div className="causes-item d-flex flex-column bg-white border-top border-5 border-primary rounded-top overflow-hidden h-100">
                <div className="text-center p-4 pt-0">
                  <div className="d-inline-block bg-primary text-white rounded-bottom fs-5 pb-1 px-3 mb-4">
                    <small>{cause.category}</small>
                  </div>
                  <h5 className="mb-3">{cause.title}</h5>
                  <p>{cause.description}</p>
                  <div className="causes-progress bg-light p-3 pt-2">
                    <div className="d-flex justify-content-between">
                      <p className="text-dark">
                        {cause.goal} <small className="text-body">Goal</small>
                      </p>
                      <p className="text-dark">
                        {cause.raised} <small className="text-body">Raised</small>
                      </p>
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${cause.percentage}%` }}
                        aria-valuenow={cause.percentage}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <span>{cause.percentage}%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="position-relative mt-auto">
                  <img className="img-fluid home-causes-image" src={cause.image} alt={cause.title} />
                  <div className="causes-overlay">
                    <a
                      className="btn btn-outline-primary"
                      href={DONATE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Donate Now
                      <div className="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2">
                        <i className="fa fa-arrow-right"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CausesSection;

